<template>

    <div class="row h-100 justify-content-center align-items-center bg-danger text-light">

        <div class="col-11 col-sm-8">

            <h1>Ingrese sus datos</h1>

            <select name="franquicia" v-model="user.franquicia_id" class="form-control form-control-lg mt-4">

                <option :value="null">(Seleccione la franquicia)</option>

                <option v-for="franquicia in franquicias" :value="franquicia.id" :key="franquicia.id">
                     {{ franquicia.nombre }}
                </option>

            </select>

            <input type="text" class="form-control form-control-lg mt-4" v-model="user.nombre" placeholder="Nombre" />

            <input
                type="text"
                class="form-control form-control-lg mt-4"
                v-model="user.apellido"
                placeholder="Apellido"
            />

            <input type="email" class="form-control form-control-lg mt-4" v-model="user.email" placeholder="Email" />

            <div class="row">

                <div class="col-sm-6">

                    <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="startIdea">
                         Idea
                    </button>

                </div>

                <div class="col-sm-6">

                    <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="startProject">
                         Proyecto
                    </button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import router from "../router";
import { mapActions } from "vuex";
import axios from "axios";

export default {
    data() {
        return {
            user: {
                nombre: null,
                apellido: null,
                email: null,
                franquicia_id: null,
            },
            franquicias: [],
        };
    },
    computed: {
        disabled: function() {
            return (
                this.user.nombre === null ||
                this.user.apellido === null ||
                this.user.email === null ||
                this.user.franquicia_id === null
            );
        },
    },
    mounted() {
        axios
            .get("/api/funnel/franquicias")
            .then((res) => {
                this.franquicias = res.data;
            })
            .catch((err) => {
                console.log(err);
                alert("Hubo un error al obtener las franquicias");
            });
    },
    methods: {
        startProject() {
            this.clearProject();
            this.setUser(this.user);
            router.push("Project1");
        },
        startIdea() {
            this.clearIdea();
            this.setUser(this.user);
            router.push("Idea1");
        },
        ...mapActions(["clearProject", "clearIdea", "setUser"]),
    },
};
</script>

